import { Outlet, createFileRoute } from "@tanstack/react-router";
import { TbCalendarTime } from "react-icons/tb";

import { PERMISSIONS } from "@/constants/permissions";
import { APP_ROUTES_FULL, APP_ROUTES_TO } from "@/utils/routes";

export const Route = createFileRoute(APP_ROUTES_FULL.MANAGEMENT_SCHEDULES)({
    component: RouteComponent,
    staticData: {
        config: {
            breadcrumb: {
                title: "schedule_overview",
                to: APP_ROUTES_TO.MANAGEMENT_SCHEDULES,
            },
            sidebar: {
                label: "user_schedules",
                icon: TbCalendarTime,
            },
            title: "schedule_overview",
        },
        permissions: [PERMISSIONS.CALL_SCHEDULE_READ],
    },
});

function RouteComponent() {
    return <Outlet />;
}
